import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  useIsMobile,
} from '@design-system';

import { Loader2, UserPlus } from 'lucide-react';

import { useFillIntakeFormTrigger, useFillIntakeForm } from '@/features/fill-intake-form';

function FillIntakeFormContent() {
  const { form, onSubmit, isLoading } = useFillIntakeForm();

  return (
    <Form {...form}>
      <form
        onSubmit={onSubmit}
        className="space-y-6"
      >
        <div className="space-y-6">
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>First name</FormLabel>
                <FormControl>
                  <Input
                    placeholder="John"
                    disabled={isLoading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Last name</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Doe"
                    disabled={isLoading}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={!form.formState.isValid || isLoading}
        >
          {isLoading ? (
            <>
              <Loader2 className="size-4 animate-spin" />
              Creating...
            </>
          ) : (
            <>
              <UserPlus className="size-4" />
              Add Client & Open Form
            </>
          )}
        </Button>
      </form>
    </Form>
  );
}

export function FillIntakeFormDialog() {
  const isMobile = useIsMobile();
  const { isFillIntakeFormOpen, closeFillIntakeForm } = useFillIntakeFormTrigger();

  const title = 'Fill Intake Form for Client';
  const description =
    "Enter your client's name to add them and complete the intake form on their behalf. No invitation will be sent.";

  if (isMobile) {
    return (
      <Drawer
        open={isFillIntakeFormOpen}
        onOpenChange={open => {
          if (!open) closeFillIntakeForm();
        }}
      >
        <DrawerContent className="max-h-[90vh] overflow-y-auto px-4 pb-6">
          <DrawerHeader className="mb-4 text-left">
            <DrawerTitle>{title}</DrawerTitle>
            <DrawerDescription>{description}</DrawerDescription>
          </DrawerHeader>
          <FillIntakeFormContent />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog
      open={isFillIntakeFormOpen}
      onOpenChange={open => {
        if (!open) closeFillIntakeForm();
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader className="mb-2">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <FillIntakeFormContent />
      </DialogContent>
    </Dialog>
  );
}
